export default __webpack_public_path__ + "static/media/METROBANK_PERSONAL.15d0931f.svg";